import { useMutation } from '../';
import { updateCustomPortalMutation } from '../mutations';

export function useUpdateCustomPortalMutation() {
  const { data, isLoading, mutate } = useMutation();
  
  const run = (variables, onFinish) => {
    mutate(updateCustomPortalMutation, variables, () => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    });
  };

  return { data, isLoading, run };
}
